import { render, staticRenderFns } from "./require-contract.vue?vue&type=template&id=f0848c34&scoped=true&"
import script from "./require-contract.vue?vue&type=script&lang=js&"
export * from "./require-contract.vue?vue&type=script&lang=js&"
import style0 from "./require-contract.vue?vue&type=style&index=0&id=f0848c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0848c34",
  null
  
)

component.options.__file = "require-contract.vue"
export default component.exports